module.exports = __webpack_public_path__ + "static/undraw_teaching_f1cm-dac829466b6d6e252ce70cfc049ce683.svg";